import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import Scroller from '../component/Scroller'
import Videos from '../component/Videos'


import { fetchFromAPI } from '../utils/fetchFromApi'



const Feed = () => {
    const[selectedCategory, setSelectedCategory]=useState('New');
    const[videos, setVideos]=useState([]);
    useEffect(()=>{
           fetchFromAPI(`search?part=snippet&q=${selectedCategory}`)
            .then((data)=>setVideos(data.items)).catch((err)=>{
              console.log(err);

            })

    },[selectedCategory])
    // console.log(videos);
  return (
    <div>
         <Scroller selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />
        <h3 className='fw-bold ms-2'>{selectedCategory}<span className='text-danger mx-2'>videos</span> </h3>
        <Videos videos={videos} />
    </div>
  )
}

export default Feed
